var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp-filter-form-item",class:{ 'label': _vm.label }},[_c('div',{staticClass:"form-item__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"form-item__content",class:_vm.size},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }